import { useEffect, useState } from 'react';
import { InvestorProjectDetail } from '../models/investors';
import useProject from '../hooks/useProject';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { listToSelectOptionAdapter } from '../../../adapters/listAdapter';
import { ProjectLayoutView } from '../constants/projectConstants';
import { Button, Col, Form, FormGroup, Row } from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';

interface Props {
  projectId: string;
  project: InvestorProjectDetail;
}

const ProjectUpdateLayoutForm = ({ projectId, project }: Props) => {
  //load proyect info

  const navigate = useNavigate();

  const { doUpdateProject } = useProject();

  const handleUpdate = async (form: InvestorProjectDetail) => {
    const result = await doUpdateProject(projectId, form);
    if (result === 200) navigate(0);
  };

  //project is load

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm<InvestorProjectDetail>({
    resolver: yupResolver(
      yup
        .object({
          layout: yup.string().required('Requerido'),
        })
        .required(),
    ),
  });

  useEffect(() => {
    if (project) {
      reset({
        layout: project.layout,
      });
    }
  }, [project]);

  const availableLayout = listToSelectOptionAdapter(
    [
      {
        label: 'Por defecto',
        value: ProjectLayoutView.DEFAULT,
      },
      {
        label: 'Resumen',
        value: ProjectLayoutView.SUMMARIZE,
      },
      {
        label: 'Torre',
        value: ProjectLayoutView.TOWER,
      },
      {
        label: 'Torre V2',
        value: ProjectLayoutView.NEW_TOWER,
      },
      {
        label: 'Detallado',
        value: ProjectLayoutView.DETAILED,
      },
      {
        label: 'Detallado sin precio',
        value: ProjectLayoutView.DETAILED_PRICELESS,
      },
    ],
    'value',
    'label',
  );

  return (
    <Form role="form" onSubmit={handleSubmit(handleUpdate)}>
      <Row>
        <Col>
          {' '}
          <FormGroup>
            <label className="form-control-label" htmlFor="status">
              Tipo de layout
            </label>
            <Controller
              name="layout"
              control={control}
              render={({ field }) => (
                <Select
                  options={availableLayout}
                  placeholder="Selecciona tipo de layout"
                  onChange={(event) => {
                    setValue('layout', event?.value);
                  }}
                  defaultValue={availableLayout.find(
                    (p) => p.value === project?.layout,
                  )}
                />
              )}
            />
            <h5 className="text-danger">{errors.layout?.message}</h5>
          </FormGroup>
          <Button color={'success'}>Actualizar</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ProjectUpdateLayoutForm;
